/**
 * @file   copy2clipboard.js
 * @author zhengchanglong<zhengchanglong@baidu.com>
 * @date   2019-09-19
 */
/**
 * 复制文本到剪切板
 *
 * @param {string} str 待复制的字符串
 * @param {Function} cbk 回调函数，接收一个复制成功与否的参数
 */
export default function copyToClipBoard(str, cbk) {
    const mark = document.createElement('textarea');
    mark.setAttribute('readonly', 'readonly');
    mark.value = str;
    mark.style.position = 'fixed';
    mark.style.top = 0;
    mark.style.clip = 'rect(0, 0, 0, 0)';
    document.body.appendChild(mark);
    mark.select();
    let isCopyed = document.execCommand('copy');
    cbk && cbk(isCopyed);
    document.body.removeChild(mark);
}
